import React from 'react';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import {mobile,tablate} from "../responsive"

const Container = styled.div`
  width: 98vw;
    margin: 1vw;
    background-color: aliceblue;
`
const CategoryItems = styled.div`
   width: 100%;
    height: 500px;
    position: relative;
`
const Image = styled.img`
   width: 100%;
    height: 100%;
    object-fit: cover;
`
const Info = styled.div`
  position: absolute;
    top: 45%;
    left:20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    ${mobile({left:"15%"})};
    ${tablate({left:"22%"})};
`
const InfoTitle = styled.h5`
  font-size: 25px;
    color: #fff;
    margin: 10px;
    /* box-shadow: 2px 2px 2px black; */
    text-shadow: 2px 2px 2px black ;
    text-transform: uppercase;
    ${tablate({fontSize:"20px"})}
`
const Button = styled.button`
   background-color: #fff;
    border: none;
    color: rgb(131, 129, 129);
    padding: 10px;
    cursor: pointer;
    font-weight: 700;
`
const CategoryItem = ({ item }) => {
  return (
    <>
      <Container>
      <Link to={`/products/${item.cat}`}>
        <CategoryItems>
          <Image src={item.img}/>
          <Info>
            <InfoTitle>{item.title}</InfoTitle>
            <Button>SHOP NOW</Button>
          </Info>
        </CategoryItems>
        </Link>

      </Container>
    </>
  )
}

export default CategoryItem